import React, { useState, useContext, useMemo } from 'react';

import { useReactFlow } from 'reactflow';

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from 'reactstrap';

import FieldError from '../../../helper/FieldError';

import {
  tooltipInitializaer
} from '../../../helper/form';

import WorkflowHttpRequestInputStageFormFileItemList from './http_request/input_stage/file_item/list';
import WorkflowHttpRequestOutputStageFormFileItemList from './http_request/output_stage/file_item/list';

import WorkflowDiagramContext from '../../diagram_context';

import WorkflowHttpRequestBodyRequestForm from './http_request/body_request/form';
import WorkflowHttpRequestBodyResponseForm from './http_request/body_response/form';

const WorkflowHttpRequestNodeForm = props => {
  const [currentNode, setCurrentNode] = useState(props?.currentNode || {});

  const { setNodes } = useReactFlow();

  const {
    callbacks: {
      unSelectNodeOnEdit,
    },
    configuration: {
      stage: {
        defaultRequestParams: stageDefaultRequestParams,
        formName: stageFormName
      }
    },
    refs: { modalNodeFormRef },
    helpers: { getStageFormData },
    services: {
      stage: {
        updateService: updateStageService
      }
    }
  } = useContext(WorkflowDiagramContext);

  // ---------- START INITIALIZE ----------
  const onOpenedModal = event => {
    tooltipInitializaer()
  }
  // ---------- END INITIALIZE ----------
  // ----------------------------------------

  // ---------- START ON CHANGE EVENTS ----------
  const onChangeCurrentNode = (event, key) => {
    let value = event?.target?.value;
    let _currentNode = { ...currentNode }

    _.set(_currentNode, key, value)

    setCurrentNode(_currentNode);
  }
  // ---------- END ON CHANGE EVENTS ----------
  // ----------------------------------------
  // ---------- START NAME ----------
  const nameInput = () => {
    return(
      <FormGroup>
        <FieldError errors={ _.get(currentNode, 'data.errors.name') }>
          <Label>
            { I18n.t('activerecord.attributes.workflow/stage.name') }
          </Label>
          <Input
            onChange={ e => onChangeCurrentNode(e, 'data.label') }
            value={ currentNode?.data?.label }
            invalid={ _.has(currentNode, 'data.errors.name') }
            autoFocus
          />
        </FieldError>
      </FormGroup>
    )
  }
  // ---------- END NAME ----------
  // ----------------------------------------
  // ---------- START DESCRIPTION ----------
  const descriptionInput = () => {
    return(
      <FormGroup>
        <FieldError errors={ _.get(currentNode, 'data.errors.description') }>
          <Label>
            { I18n.t('activerecord.attributes.workflow/stage.description') }
          </Label>
          <Input
            type='textarea'
            value={ currentNode?.data?.description }
            onChange={e => onChangeCurrentNode(e, 'data.description')}
            invalid={_.has(currentNode, 'data.errors.description')}
          />
        </FieldError>
      </FormGroup>
    )
  }
  // ---------- END DESCRIPTION ----------
  // ----------------------------------------

  // ---------- START STAGE FORM ----------

  const stageForm = () => {
    return (
      <Row>
        <Col className="col-12">
          {/* Se programa con bootstrap tabs para no manejar estados */}
          {/* reactstrap obliga a manejar un estado para cambiar de tabs */}

          <ul className="nav nav-pills nav-justified" id="stageFormTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="input-stage-form-tab"
                data-bs-toggle="tab"
                data-bs-target="#input-stage-form"
                type="button"
                role="tab"
                aria-controls="input-stage-form"
                aria-selected="true"
              >
                {I18n.t('activerecord.models.workflow/input_stage_form.other')}
              </button>
            </li>

            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="body-request-content-tab"
                data-bs-toggle="tab"
                data-bs-target="#body-request-content"
                type="button"
                role="tab"
                aria-controls="body-request-content"
                aria-selected="false"
              >
                {I18n.t('activerecord.attributes.workflow/stage.body_request_content')}
              </button>
            </li>

            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="output-stage-form-tab"
                data-bs-toggle="tab"
                data-bs-target="#output-stage-form"
                type="button"
                role="tab"
                aria-controls="output-stage-form"
                aria-selected="false"
              >
                {I18n.t('activerecord.models.workflow/output_stage_form.other')}
              </button>
            </li>

            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="response-body-tab"
                data-bs-toggle="tab"
                data-bs-target="#response-body"
                type="button"
                role="tab"
                aria-controls="response-body"
                aria-selected="false"
              >
                Response Body
              </button>
            </li>
          </ul>

          <div className="tab-content" id="stageFormTabContent">
            <div
              className="tab-pane fade show active pt-3"
              id="input-stage-form"
              role="tabpanel"
              aria-labelledby="input-stage-form-tab"
            >
              <WorkflowHttpRequestInputStageFormFileItemList
                currentNode={currentNode}
                callbacks={{
                  onSetCurrentNode: setCurrentNode,
                  activeInputStageFileItems: activeInputStageFileItems
                }}
                configuration={{
                  stageForm: 'input_stage_form'
                }}
              />
            </div>

            <div
              className="tab-pane fade pt-3"
              id="body-request-content"
              role="tabpanel"
              aria-labelledby="body-request-content-tab"
            >
              <WorkflowHttpRequestBodyRequestForm
                currentNode={currentNode}
                callbacks={{
                  onSetCurrentNode: setCurrentNode,
                  onChangeCurrentNode: onChangeCurrentNode,
                  activeInputStageFileItems: activeInputStageFileItems
                }}
              />
            </div>

            <div
              className="tab-pane fade pt-3"
              id="output-stage-form"
              role="tabpanel"
              aria-labelledby="output-stage-form-tab"
            >
              <WorkflowHttpRequestOutputStageFormFileItemList
                currentNode={currentNode}
                callbacks={{
                  onSetCurrentNode: setCurrentNode,
                  activeOutputStageFileItems: activeOutputStageFileItems
                }}
                configuration={{
                  stageForm: 'output_stage_form'
                }}
              />
            </div>

            <div
              className="tab-pane fade pt-3"
              id="response-body"
              role="tabpanel"
              aria-labelledby="response-body-tab"
            >
              <WorkflowHttpRequestBodyResponseForm
                currentNode={currentNode}
                callbacks={{
                  onSetCurrentNode: setCurrentNode,
                  onChangeCurrentNode: onChangeCurrentNode,
                  activeOutputStageFileItems: activeOutputStageFileItems
                }}
              />
            </div>

          </div>
        </Col>
      </Row>
    )
  }
  // ----------------------------------------
  // ---------- START SUBMIT ----------
  const onSubmitStage = event => {
    let _currentNode = { ...currentNode }

    const requestParams = {
      ...stageDefaultRequestParams,
      ...{ id: currentNode?.data?.id }
    }

    const formData = getStageFormData(_currentNode);

    updateStageService(requestParams, formData, response => {
      if (response.status == 200) {
        setNodes((nds) => {
          return _.map(nds, nd => {
            if (nd.id == currentNode.id) {
              nd = response.data.config_react_flow
            }
            return nd
          })
        })

        unSelectNodeOnEdit()

        swalToastBootstrap.fire({
          icon: 'success',
          title: I18n.t('workflow.stages.update.successfully')
        });
      } else {
        setCurrentNode(response.data.config_react_flow)
        swalToastBootstrap.fire({
          icon: 'error',
          title: I18n.t('errors.unprocessable_content')
        });
      }
    })
  }
  // ---------- END SUBMIT ----------
  // ----------------------------------------
  // ---------- START HELPERS ----------
  const activeInputStageFileItems = useMemo(() => {
    return _.filter(currentNode?.data?.input_stage_form?.file_items || [], item => !item._destroy)
  }, [currentNode?.data?.input_stage_form?.file_items])

  const activeOutputStageFileItems = useMemo(() => {
    return _.filter(currentNode?.data?.output_stage_form?.file_items || [], item => !item._destroy)
  }, [currentNode?.data?.output_stage_form?.file_items])

  // ---------- END HELPERS ----------
  // ----------------------------------------

  return (
    <Modal
      isOpen={modalNodeFormRef.current}
      toggle={unSelectNodeOnEdit}
      size='xl'
      unmountOnClose={true}
      onOpened={event => onOpenedModal(event)}
    >
      <ModalHeader
        toggle={ unSelectNodeOnEdit }
      >
        <i className="fas fa-project-diagram mr-2"></i>
        { I18n.t('workflow.stages.form.configuration') }
      </ModalHeader>
      <ModalBody>
        { nameInput() }
        { descriptionInput() }

        { stageForm() }
      </ModalBody>

      <ModalFooter>
        <Button color="default" onClick={unSelectNodeOnEdit}>
          {I18n.t('actions.close')}
        </Button>
        <Button
          color="success" onClick={onSubmitStage}>
          Guardar Etapa
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default WorkflowHttpRequestNodeForm;
